import { ProductoPresentacion } from './ProductoPresentacion';

export class Familia {
    codigoFamilia: number;
    nombre: string;
    descripcion: string;
    productosPresentacion: ProductoPresentacion[] = [];
}